import {
    LAUNCHER_UPDATE_READY_STATE,
} from '../constants'

// eslint-disable-next-line
export function actionLauncherSetReadyState(ready) {
    return {
        type: LAUNCHER_UPDATE_READY_STATE,
        payload: ready,
    }
}



// WEBPACK FOOTER //
// ./src/actions/launcher.js